// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import HolderOutlinedSvg from "@ant-design/icons-svg/lib/asn/HolderOutlined";
import AntdIcon from "../components/AntdIcon";
const HolderOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: HolderOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    HolderOutlined.displayName = "HolderOutlined";
}
export default /*#__PURE__*/ React.forwardRef(HolderOutlined);
